// Get all modals (used to open/close aka. display/none)
let modals = document.getElementsByClassName("modal-container");

// Trigger Area to Open Modal. (Image itself)
let modalOpener = document.getElementsByClassName("open-modal");

// X button that closes the modal
let closeModalButtons = document.getElementsByClassName("close-modal");

attachEventListener()

function attachEventListener() {
    // Attach EvenListener to each modalOpener
    for (let i = 0; i < modalOpener.length; i++) {
        modalOpener[i].addEventListener("click", () => displayModal(i));
    }

    // Attach EvenListener to each "X"
    for (let i = 0; i < closeModalButtons.length; i++) {
        closeModalButtons[i].addEventListener("click", () => closeModal(i));
    }
}

// Help Functions
function displayModal(modalID) {
    // modals[modalID].style.display = "block";
    modals[modalID].classList.remove("hide-modal")

    header = document.getElementsByClassName("header-wrapper");
    header[0].style.display = "none"
}

function closeModal(modalID) {
    // modals[modalID].style.display = "none";
    modals[modalID].classList.add("hide-modal")

    header = document.getElementsByClassName("header-wrapper");
    header[0].style.display = "block"
}



/* ---------------------------------------------------------------------------------------------- 
    When the filter is applied, the eventListeners need to be re-attached to the elements.
    The Code below detects when the container has been changed (by filter) and then re-applies
    the eventListeners.

    The Modal uses << product-grid-container >> for detecting changes + callback and observer have
    a 2 attached to them, because otherwise the variables somehow clash with custom-slideshow.js 
 ---------------------------------------------------------------------------------------------- */
let container = document.getElementsByClassName("product-grid-container")[0]; 
const config2 = { attributes: true, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback2 = (mutationList, observer) => {
    attachEventListener()
};

// Create an observer instance linked to the callback function
const observer2 = new MutationObserver(callback2);

// Start observing the target node for configured mutations
observer2.observe(container, config2);